/* eslint-disable import/prefer-default-export */
import api from '.';

const API_URL = '/api/v1/public/configs';

/** @returns {Promise<ApiPublicConfigs.GetPublicConfigsResponse>} */
export const getPublicConfigs = () => api.get(API_URL);
